var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuIcon = function SvgMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.021 1.667a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M1.771 9.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m5.73 0a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m8.083-2.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M1.667 15.583a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M7.5 3.916a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m8.084-2.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M9.125 15a1.042 1.042 0 1 0 0 2.083 1.042 1.042 0 0 0 0-2.083m3.75 0a1.042 1.042 0 1 0 0 2.083 1.042 1.042 0 0 0 0-2.083m2.709 1.041a1.042 1.042 0 1 1 2.083 0 1.042 1.042 0 0 1-2.083 0",
    clipRule: "evenodd"
  })));
};
export default SvgMenuIcon;